export default "__VITE_ASSET__G0lbN3Lb__"